/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

// Typography styles for modals
export const modalTitleStyles = {
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "24px",
  letterSpacing: "0.15px",
  color: "#121415",
};

export const modalBodyTextStyles = {
  width: "375px",
  height: "40px",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "140%",
  letterSpacing: "0.15px",
  color: "#5A5B5C",
};

export const fieldLabelStyles = {
  minWidth: "122px",
  height: "19px",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "100%",
  letterSpacing: "0px",
  verticalAlign: "middle",
  color: "#2A2C2D",
};

export const requiredAsteriskStyles = {
  marginLeft: "4px",
  color: "#B50B00",
};
